import { isString } from '../../helpers/type';
import { Options, ExtJson, ReportParams } from '../types';
import { optionKeys } from './constant';

// 参数拆分，将参数拆分为pageType、actionType、options、extJson
export const splitParams = (params: ReportParams) => {
    const { eventId, pageType = '', actionType = '', __trackMode, ...restParams } = params;
    const options: Options = {};
    const extJson: ExtJson = {};

    // 处理剩余参数，根据key类型分配到options或extJson
    Object.keys(restParams).forEach(key => {
        const target = optionKeys.indexOf(key) > -1 ? options : extJson;
        target[key] = restParams[key];
    });

    return {
        eventId,
        pageType: isString(pageType) ? pageType : '',
        actionType: isString(actionType) ? actionType : '',
        options,
        extJson
    };
};
